import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../environments/environment';
import 'rxjs/add/operator/map';

import { LoginService } from './login.service';
import { localStorageAvailable } from '../_helpers/local-storage-available';
import { localStorageCartId } from '../_common/constants';
import { EventPerformer } from '../_models/event-performer';
import { EventPerformerExperience } from '../_models/event-performer-experience';

@Injectable()
export class EventPerformersService {
  private readonly apiController: string;

  constructor(private readonly httpClient: HttpClient, private readonly loginService: LoginService) {
    this.apiController = `${environment.webApiUrl}/api/v${environment.webApiVersion}/eventPerformers`;
  }

  getAvailableQuantityToPurchase(eventPerformerExperience: EventPerformerExperience): number {
    if (eventPerformerExperience.quantityAvailable > eventPerformerExperience.maxPurchaseQuantity) {
      return eventPerformerExperience.maxPurchaseQuantity;
    }

    return eventPerformerExperience.quantityAvailable;
  }

  getEventPerformer(eventPerformerId: number): Observable<EventPerformer> {
    let cartId = '';

    if (localStorageAvailable()) {
      cartId = localStorage.getItem(localStorageCartId) as string;
    }

    let userId = 0;
    const authUser = this.loginService.getLoggedInUser();
    if (authUser !== null) {
      userId = authUser.userId;
    }

    return this.httpClient.get<EventPerformer>(`${this.apiController}/getEventPerformer?eventPerformerId=${eventPerformerId}&cartUid=${cartId}&userId=${userId}`)
      .map(
        (eventPerformer: EventPerformer) => {
          return eventPerformer;
        }
      );
  }

  getEventPerformerExperience(eventPerformerExperienceId: number): Observable<EventPerformerExperience> {
    return this.httpClient.get<EventPerformerExperience>(`${this.apiController}/getEventPerformerExperience?eventPerformerExperienceId=${eventPerformerExperienceId}`)
      .map(
        (eventPerformerExperience: EventPerformerExperience) => {
          return eventPerformerExperience;
        }
      );
  }

  getEventPerformers(eventId: number): Observable<EventPerformer[]> {
    return this.httpClient.get<EventPerformer[]>(`${this.apiController}/getEventPerformers?eventId=${eventId}`)
      .map(
        (eventPerformers: EventPerformer[]) => {
          return eventPerformers;
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/event-performers.service.ts